import * as Types from '../types'

// internal use only
export function reducerAdded(storeTarget, global) {
    const action = {
        type: Types.REDUX_REDUCER_ADDED,
        meta: {
            storeTarget
        }
    }
    if (global) {
        action.meta.global = true
    }
    return action
}

// internal use only
export function reducerRemoved(storeTarget, global) {
    const action = {
        type: Types.REDUX_REDUCER_REMOVED,
        meta: {
            storeTarget
        }
    }
    if (global) {
        action.meta.global = true
    }
    return action
}

// internal use only
export function removeState(storeTarget) {
    return {
        type: Types.REDUX_STATE_REMOVE,
        payload: {
            storeTarget
        }
    }
}
